import type { FC } from 'react'

import type { SelectOption } from '@/components/Select'
import Select from '@/components/Select'
import { AdverseCreditDeclaration } from '@/types/adverseCredit'

const selectOptions: SelectOption<AdverseCreditDeclaration>[] = [
  {
    value: AdverseCreditDeclaration.declared,
    label: 'Declared',
  },
  {
    value: AdverseCreditDeclaration.undeclared,
    label: 'Undeclared',
  },
]

interface Props {
  selectedValue: AdverseCreditDeclaration
  onSelect: (newValue: AdverseCreditDeclaration) => void
  disabled?: boolean
}

const DeclarationSelect: FC<Props> = ({ selectedValue, onSelect, disabled }) => (
  <Select
    selectedValue={selectedValue}
    options={selectOptions}
    onSelect={onSelect}
    disabled={disabled}
  />
)

export default DeclarationSelect
